<template>
	<div>
		<div class="filter-tag-row">
			<ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/>
			<span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">Услуг найдено: {{this.masApi_total}}</span>
		</div> 
		<div class="row" v-show="bShowFilter">
			<div class="col-12"><ReFilter
				:masAllFilterParams="masAllFilterParams"
				v-model="objGetParams"
				v-on:filterapply="OnFilterApply"
				name="services"
			/></div>
		</div>
		<div>
			<ReSearchCardService v-for="objService in masApi" :objService="objService" :key="objService.id"/>
		</div>
		
		<Pagination :class="[{'': parseInt(masApi_total) > 0}, {'d-none': parseInt(masApi_total) < 1}]"
			:type="'info'" 
			:total="parseInt(masApi_total)" 
			:perPage="parseInt(10)" 
			:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
			:pClick="pClick">
		</Pagination>
		
	</div>
</template>
<script>

import {eventEmitter} from "src/plugins/globalComponents.js";
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
// import ReServiceMultiOp from 'src/our_components/ReServiceMultiOp.vue';
import Pagination from 'src/our_components/RePagination';
import ReSearchCardService from 'src/our_components/ReSearchCardService';

export default {
	name: 'Services',
	components: {
		ReFilter,
		ReFilterBtn,
		// ReServiceMultiOp,
		Pagination,
		ReSearchCardService,
	},
	data() {
		return {
			ApiData: {},
			objGetParams: {},
			masAllFilterParams: this.currentFilterConfig(),
			bShowFilter: false,
			masApi: [],
			masApi_total:0,
		};
	},
	methods: {
		getApi(){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getApi',this.objGetParams);
				filter = this.objGetParams;
			}

			//console.log('getApi',filter);
			this.$GVO.ApiCall('GET_SERVICES',{obj:'services' ,flt:{...filter,objectPhoto:true} })
			.then((objApi) => { 
				this.masApi_total = 0;
				this.masApi = [];
				if(objApi.success === true){ //console.log(objApi);
					this.masApi = objApi.data;
					if(objApi.total!=undefined) { this.masApi_total=objApi.total; }
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		currentFilterConfig(){
			this.$GVO.ApiCall('GET_FILTER_SERVICES',{obj:'services'})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						this.masAllFilterParams = objApi.config;
						eventEmitter.$emit('OnFilterConfigLoad', this.masAllFilterParams);
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		OnFilterApply(data){
			//this.objGetParams = data;
			//console.log('OnFilterApply',data);
			//console.log('OnFilterApply',this.objGetParams);
			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
				}
			}
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			this.getApi();
		},
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			this.OnFilterApply();
		},
	},
	mounted() {
		this.objGetParams = this.$GVO.GetAllGet();
		//this.getApi();
		//this.$GVO.LoadCatPromise('CAT_ROOMS').then((objCat) => {}).catch(errorObjApi => {console.log(errorObjApi);});
	}
};
</script>
<style>
.filter-tag-row {
	display: flex;
	flex-flow: row nowrap;
	align-items: center;
}
.filter-tag-row .el-tag--plain {
	font-size: 16px;
}
@media (max-width: 576px){
	.filter-tag-row {padding: 0 15px;}
}
</style>
